
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { renderSVG } from './utils/render.mjs.js';
import { scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs.js';
import { makeUseVisualState } from '../../motion/utils/use-visual-state.mjs.js';
import { createSvgRenderState } from './utils/create-render-state.mjs.js';
import { buildSVGAttrs } from './utils/build-attrs.mjs.js';

var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: function (props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

export { svgMotionConfig };
//# sourceMappingURL=config-motion.mjs.js.map
